import { login as doLogin, logout as doLogout } from "$lib/stores/auth";

const apiUrl = import.meta.env.VITE_API_URL;

  type Credentials = {email: string, password: string};
  export async function login(credentials: Credentials) 
  {
    const res = await fetch(`${apiUrl}/auth/login`, { //TODO: fetch from correct server
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials)
    });

    if (!res.ok) {
      let returnedValue: any = await res.json();
      alert(`Login failed. Status ${res.status}. Error: ${returnedValue.message || "Unknown"}`);
      return false;
    }

    const data = await res.json();
    doLogin(data.token);
    return true;
  }

  export function logout() {
    doLogout();
  }